import { useTheme } from "../theme";

/**
 * Official LaunchDarkly wordmark, swapped for the active theme: the black
 * ("Dark") logo on light backgrounds, the white logo on dark backgrounds.
 */
export default function BrandLogo({ height = 22 }: { height?: number }) {
  const { resolved } = useTheme();
  const src = resolved === "dark" ? "/brand/launchdarkly-white.svg" : "/brand/launchdarkly-dark.svg";
  return <img src={src} alt="LaunchDarkly" style={{ height, width: "auto" }} />;
}
